import MiHeader from './MiHeader.vue'

export default MiHeader
